import { Pipe, PipeTransform } from '@angular/core';
import {
  CounterParamDelayModification,
  CounterRangeDelayConfig,
  DeliveryTimeModifier,
} from '../types';
import { filterLimitations } from './helpers';

function calculateDeliveryTimeModification(
  hasExpandedPrice: boolean,
  timeExpandedModification: Array<DeliveryTimeModifier>,
  timeSimpleModification: number,
  picked: { [x: string]: string | boolean | number }
): number {
  let start = 0;
  if (hasExpandedPrice) {
    const filteredModifiers = filterLimitations(
      timeExpandedModification,
      picked
    );
    filteredModifiers.sort(
      (a, b) =>
        Object.entries(b.config).length - Object.entries(a.config).length
    );
    if (filteredModifiers.length) {
      start += Number(filteredModifiers[0].delay);
    }
  } else {
    start += Number(timeSimpleModification);
  }
  return start;
}

function calculateDeliveryTimeModificationForCounter(
  currentCounter: number,
  hasExpandedPrice: boolean,
  timeExpandedModification: Array<CounterParamDelayModification>,
  timeSimpleModification: Array<CounterRangeDelayConfig>,
  picked: { [x: string]: string | boolean | number }
): number {
  let start = 0;
  if (hasExpandedPrice) {
    const filteredModifiers = filterLimitations(
      timeExpandedModification,
      picked
    );

    filteredModifiers.sort(
      (a, b) =>
        Object.entries(b.config).length - Object.entries(a.config).length
    );
    if (filteredModifiers.length) {
      start += Number(
        filteredModifiers[0].change
          .slice()
          .sort((a, b) => b.min - a.min)
          .find(
            ({ min, max }) => currentCounter >= min && currentCounter <= max
          )?.value
      );
    }
  } else {
    const change = Number(
      timeSimpleModification
        .slice()
        .sort((a, b) => b.min - a.min)
        .find(({ min, max }) => currentCounter >= min && currentCounter <= max)
        ?.value
    );
    if (!isNaN(change)) {
      start += change;
    }
  }
  return start;
}

@Pipe({
    name: 'timeToDeliveryWithConfigParser',
    standalone: false
})
export class TimeToDeliveryWithConfigParserPipe implements PipeTransform {
  constructor() {}

  transform(value, picked: { [x: string]: string | boolean | number }): string {
    console.log(value);
    let newPrice = value?.deliveryTime ? value.deliveryTime : 0;
    const pickedIndexes = Object.keys(picked).filter((i) => !!picked[i]);
    value?.config
      .filter(({ type, booleanConfig, customId, options, counterConfig }) => {
        const optionSelected = pickedIndexes.indexOf(customId) !== -1;
        const mayHavePriceModifier =
          ['boolean', 'list', 'size', 'counter', 'decoration'].indexOf(type) !==
          -1;
        const hasOptionsWithModifiers = options?.filter(
          ({ deliveryTimeModifier }) => deliveryTimeModifier
        ).length;
        const hasTimeModifier =
          booleanConfig?.deliveryTimeModifier ||
          hasOptionsWithModifiers ||
          counterConfig?.deliveryTimeModifier;
        return optionSelected && mayHavePriceModifier && hasTimeModifier;
      })
      .forEach(({ type, booleanConfig, customId, options, counterConfig }) => {
        switch (type) {
          case 'boolean':
            newPrice += calculateDeliveryTimeModification(
              booleanConfig.hasExpandedDeliveryTimeModification,
              booleanConfig.deliveryTimeExpandedModification,
              booleanConfig.simpleDeliveryTimeModification,
              picked
            );
            break;
          case 'list':
          case 'decoration':
          case 'size':
            if (Object.keys(picked).indexOf(customId) !== -1) {
              const {
                hasExpandedDeliveryTimeModification,
                deliveryTimeExpandedModification,
                simpleDeliveryTimeModification,
              } = options.find(({ configId }) => configId === picked[customId]);
              newPrice += calculateDeliveryTimeModification(
                hasExpandedDeliveryTimeModification,
                deliveryTimeExpandedModification,
                simpleDeliveryTimeModification,
                picked
              );
            }
            break;
          case 'counter':
            newPrice += calculateDeliveryTimeModificationForCounter(
              Number(picked[customId]),
              counterConfig.hasExpandedDeliveryTimeModification,
              counterConfig.deliveryTimeExpandedModification,
              counterConfig.simpleDeliveryTimeModification,
              picked
            );
            break;
        }
      });
    if (isNaN(Number(newPrice))) {
      newPrice = 0;
    }

    return String(Math.max(0, newPrice));
  }
}
